import api from '../../lib/api';

export type RootCauseDraftStep = {
  order: number;
  tool: string;
  inputText?: string;
  outputText?: string;
  notes?: string;
};

export type RootCauseDraft = {
  steps?: RootCauseDraftStep[];
  rootCauses?: Array<{ description: string }>;
  summary?: string;
};

export type SuggestRootCauseResult = {
  draft: RootCauseDraft;
  text: string;
  logId: string;
  tokensIn: number;
  tokensOut: number;
};

export type AiDraftResult = {
  draft: Record<string, unknown>;
  text: string;
  logId: string;
  tokensIn: number;
  tokensOut: number;
};

export async function suggestRootCause(payload: {
  ncId?: string;
  draftDescription?: string;
}): Promise<SuggestRootCauseResult> {
  const { data } = await api.post('/platform/ai/qms/suggest-root-cause', payload, {
    timeout: 120_000,
  });
  return data.data as SuggestRootCauseResult;
}

export async function fetchMrvDraft(payload: {
  reviewId?: string;
  from?: string;
  to?: string;
}): Promise<AiDraftResult> {
  const { data } = await api.post('/platform/ai/mrv/draft-narrative', payload, {
    timeout: 120_000,
  });
  return data.data as AiDraftResult;
}

export async function fetchAuditDraft(payload: { auditId: string }): Promise<AiDraftResult> {
  const { data } = await api.post('/platform/ai/audit/draft-report', payload, {
    timeout: 120_000,
  });
  return data.data as AiDraftResult;
}

export async function fetchImplGap(payload: {
  standard?: string;
  catalogItemId?: string;
}): Promise<AiDraftResult> {
  const { data } = await api.post('/platform/ai/impl/gap-analysis', payload, {
    timeout: 120_000,
  });
  return data.data as AiDraftResult;
}
